import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getDocs, limit as firestoreLimit } from 'firebase/firestore';
import './main.css';

// ** Receive discount prop and loggedInCustomerCode **
const Your = ({ discount = 0, maxItems = 6, loggedInCustomerCode }) => {
  const [interestedProducts, setInterestedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInterestedProducts = async () => {
      setIsLoading(true);
      setError(null);
      try {
        console.log('Fetching for customer code:', loggedInCustomerCode);
        
        // First get the code document to get interestedIn SKUs
        const codesRef = collection(db, 'codes');
        const codeQuery = query(codesRef, where('code', '==', loggedInCustomerCode));
        const codeSnapshot = await getDocs(codeQuery);
        
        if (codeSnapshot.empty) {
          console.log('No code document found for:', loggedInCustomerCode);
          setError('No customer code found.');
          setIsLoading(false);
          return;
        }

        const codeDoc = codeSnapshot.docs[0].data();
        console.log('Found code document:', codeDoc);
        
        // Convert SKUs to numbers and filter out any invalid ones
        const interestedInSkus = codeDoc.interestedIn 
          ? codeDoc.interestedIn.split(',')
              .map(sku => sku.trim())
              .map(sku => parseInt(sku, 10))
              .filter(sku => !isNaN(sku))
          : [];
        console.log('Extracted SKUs (as numbers):', interestedInSkus);

        if (interestedInSkus.length === 0) {
          console.log('No valid SKUs found in interestedIn field');
          setError('No interested products found for this code.');
          setIsLoading(false);
          return;
        }

        // Then get the products that match these SKUs
        const productsRef = collection(db, 'products');
        const productsQuery = query(
          productsRef,
          where('SKU', 'in', interestedInSkus),
          firestoreLimit(maxItems)
        );

        console.log('Querying products with SKUs:', interestedInSkus);
        const productsSnapshot = await getDocs(productsQuery);
        console.log('Found products:', productsSnapshot.docs.length);
        
        const productsData = productsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log('Products data:', productsData);
        
        setInterestedProducts(productsData);
      } catch (err) {
        console.error('Error fetching interested products:', err);
        setError('Could not load interested products.');
      } finally {
        setIsLoading(false);
      }
    };

    if (loggedInCustomerCode) {
      console.log('Starting fetch with code:', loggedInCustomerCode);
      fetchInterestedProducts();
    } else {
      console.log('No customer code provided');
      setError('Please log in to see your interested products.');
      setIsLoading(false);
    }
  }, [maxItems, loggedInCustomerCode]);

  // Use the passed discount prop
  const numericDiscount = Number(discount) || 0;

  return (
    <section className="products trending-section" id="trending">
      <h1 className="heading">You <span>Might</span> Like</h1>
      {isLoading && <p className="loading-message">Loading your interested products...</p>}
      {error && <p className="error-message">{error}</p>}
      {!isLoading && !error && (
        <>
          {interestedProducts.length > 0 ? (
            <div className="box-container">
              {interestedProducts.map(product => {
                const sellingPrice = Number(product.Rate) || 0;
                const discountedSellingPrice = (sellingPrice * (1 - numericDiscount / 100)).toFixed(2);
                const displayPrice = numericDiscount > 0 ? discountedSellingPrice : sellingPrice.toFixed(2);
                const originalPrice = sellingPrice.toFixed(2);

                return (
                  <div className="box" key={product.id}>
                    {numericDiscount > 0 && <span className="discount">-{numericDiscount}%</span>}
                    <div className="image">
                      <img 
                        src={product.image || '/placeholder.png'} 
                        alt={product["Product name"]} 
                        loading="lazy"
                        onError={(e) => { e.target.onerror = null; e.target.src = '/placeholder.png'; }}
                      />
                      <div className="icons">
                        <Link target='_blank' rel="noopener noreferrer" to={`https://wa.me/919911192881?text=...`} className="fas fa-bag-shopping" title="Request Sample"></Link>
                        <Link to={`/products/${product.id}`} className="cart-btn" title="View Product Details">View Product</Link>
                        <a href="#" className="fas fa-share" title="Copy Share Link" onClick={(e) => { /* ... */ }}></a>
                      </div>
                    </div>
                    <div className="content">
                      <h3>{product["Product name"]}</h3>
                      <p className='des'>SKU: {product.SKU || 'N/A'}</p>
                      <p className='des'> L:{product.L ?? '?'} H:{product.H ?? '?'} B:{product.B ?? '?'} (In) </p>
                      <div className="raw">Raw foam prices</div>

                      <div className="price">
                        ₹{displayPrice}
                        {numericDiscount > 0 && <span>₹{originalPrice}</span>}
                      </div>
                      <Link to={`/products/${product.id}`} className="btn"> View Details </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="no-products-message">No interested products found.</p>
          )}
          <Link to={`/products`} className="btn view-all-btn"> View all products </Link>
        </>
      )}
    </section>
  );
};

export default Your;